import { validateAcn } from '../../../../common/utils';

export const yupValidateAcn = (value: string | null | undefined): boolean => {
  const rawValue = (value || '').replace(/[\s-_]/g, '');

  if (!!rawValue) {
    return validateAcn(rawValue);
  }
  return true;
};
